// views/snapshot-shape.js: B2-1 pure snapshot normalization.
//
// Converts parity.serialize's Lua-table-as-JSON-object shape into the
// arrays the canvas helpers expect. Pure; never mutates the input.
// Lives in a .js file (not the .jsx) so Node tests can import it
// without a JSX transform step.

/**
 * @param {any} snap
 * @returns {any}
 */
export function normalizeSnapshotShape(snap) {
  if (!snap || typeof snap !== 'object') return snap;
  const next = { ...snap };
  if (snap.hands && typeof snap.hands === 'object') {
    /** @type {Record<string, string[]>} */
    const hands = {};
    for (const [seat, h] of Object.entries(snap.hands)) {
      if (Array.isArray(h)) hands[seat] = h;
      else if (h && typeof h === 'object') {
        hands[seat] = Object.values(h).filter((c) => typeof c === 'string');
      } else {
        hands[seat] = [];
      }
    }
    next.hands = hands;
  }
  if (snap.legal_plays && typeof snap.legal_plays === 'object') {
    /** @type {Record<string, string[]>} */
    const lp = {};
    for (const [seat, list] of Object.entries(snap.legal_plays)) {
      if (Array.isArray(list)) lp[seat] = list;
      else if (list && typeof list === 'object') {
        lp[seat] = Object.values(list).filter((c) => typeof c === 'string');
      }
    }
    next.legal_plays = lp;
  }
  if (snap.trick_plays !== undefined && !Array.isArray(snap.trick_plays)) {
    next.trick_plays = Object.values(snap.trick_plays || {});
  }
  if (snap.your_legal_plays !== undefined && !Array.isArray(snap.your_legal_plays)) {
    next.your_legal_plays = Object.values(snap.your_legal_plays || {})
      .filter((c) => typeof c === 'string');
  }
  if (snap.your_legal_bids !== undefined && !Array.isArray(snap.your_legal_bids)) {
    next.your_legal_bids = Object.values(snap.your_legal_bids || {})
      .filter((b) => b && typeof b === 'object');
  }
  if (snap.bid_history !== undefined && !Array.isArray(snap.bid_history)) {
    next.bid_history = Object.values(snap.bid_history || {});
  }
  if (snap.completed_tricks !== undefined && !Array.isArray(snap.completed_tricks)) {
    next.completed_tricks = Object.values(snap.completed_tricks || {});
  }
  return next;
}
